<div>
  <div *ngFor="let feature of availableFeatures"></div>
</div>
